import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["data-qa"]
const _hoisted_2 = {
  key: 1,
  class: "_my-0 gfu-summary-list-item__subtitle",
  "data-qa": "label"
}
const _hoisted_3 = ["innerHTML", "data-qa"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_tooltip = _resolveComponent("tooltip")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['gfu-summary-list-item _gap-2', $options.alignmentClass]),
    "data-qa": `summary-list-item:${$props.title}`
  }, [
    _createElementVNode("div", {
      class: _normalizeClass([{'_flex': $options.hasTooltip}])
    }, [
      _createElementVNode("p", {
        class: _normalizeClass(['_my-0', {'_fw-eb': $props.isLabelBold}])
      }, _toDisplayString($props.title), 3 /* TEXT, CLASS */),
      ($options.hasTooltip)
        ? (_openBlock(), _createBlock(_component_tooltip, {
            key: 0,
            class: "_ml-1",
            text: $props.tooltipText,
            "icon-name": "circle-info"
          }, null, 8 /* PROPS */, ["text"]))
        : _createCommentVNode("v-if", true),
      ($props.hasSubtitle)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
            _createTextVNode(_toDisplayString($props.subtitle) + " ", 1 /* TEXT */),
            ($props.hasSubtitleTooltip)
              ? (_openBlock(), _createBlock(_component_tooltip, {
                  key: 0,
                  "icon-name": "circle-info",
                  "data-qa": "taxrate-info-tooltip"
                }, {
                  content: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.subtitleTooltipContentRows, (subtitleTooltipRow, index) => {
                      return (_openBlock(), _createElementBlock("p", {
                        key: index,
                        innerHTML: subtitleTooltipRow.text,
                        "data-qa": subtitleTooltipRow.dataQa
                      }, null, 8 /* PROPS */, _hoisted_3))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true)
          ]))
        : _createCommentVNode("v-if", true)
    ], 2 /* CLASS */),
    _createElementVNode("p", {
      class: _normalizeClass([
               '_flex-none', '_my-0','gfu-summary-list-item__value',
               {'gfu-summary-list-item__value--highlighted': $props.isHighlighted},
               $options.themeClass
           ]),
      "data-qa": "value"
    }, [
      ($options.hasValueTooltip)
        ? (_openBlock(), _createBlock(_component_tooltip, {
            key: 0,
            "icon-name": "circle-info",
            text: $props.valueTooltip
          }, null, 8 /* PROPS */, ["text"]))
        : _createCommentVNode("v-if", true),
      _createTextVNode(" " + _toDisplayString($props.value), 1 /* TEXT */)
    ], 2 /* CLASS */)
  ], 10 /* CLASS, PROPS */, _hoisted_1))
}